/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { ReactComponent as BackArrowIcon } from 'assets/arrow-left.svg';
import { ReactComponent as RightArrowIcon } from 'assets/arrow-right.svg';
import { ReactComponent as GoogleAuthenticatorIcon } from 'assets/google-authenticator-icon.svg';
import { ReactComponent as WhatsAppIcon } from 'assets/whatsapp-logo.svg';
import { ReactComponent as SmsIcon } from 'assets/sms-icon.svg';
import { ReactComponent as TransferraAppIcon } from 'assets/transferra-app-icon.svg';
import { TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';
import i18nContext from 'components/i18n-context';
import { IconButton } from 'uikit/IconButton/IconButton';
import './SwitchConfirmationMethodScreen.scss';

const SwitchConfirmationMethodScreen = ({
  onSwitchMethod,
  onBack,
  currentConfirmationType,
  availableConfirmationTypes
}) => {
  const i18n = useContext(i18nContext);
  const [isClicked, setIsClicked] = useState(false);
  const isGoogle2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH);
  const isWhatsApp2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.WHATSAPP);
  const isSms2FAEnabled = availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.SMS);
  const isPushNotifications2FAEnabled =
    availableConfirmationTypes && availableConfirmationTypes?.includes(TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION);

  useEffect(() => {
    if (isClicked) {
      setIsClicked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSwitchConfirmationMethod = async (method) => {
    setIsClicked(true);
    await onSwitchMethod(method);
  };

  return (
    <div className={`authorization-form ${isClicked ? 'is-clicked-cursor' : ''}`} id={'form1'}>
      <div className={'switch-confirmation-method-title-wrapper'}>
        <IconButton className={'switch-confirmation-method-back-button'} onClick={onBack} Icon={BackArrowIcon} />
        <h1 className={'switch-confirmation-method-title'}>
          {i18n.getMessage('switchConfirmationMethodScreen.title')}
        </h1>
      </div>

      <div className={'switch-confirmation-method-list-wrapper'}>
        {isPushNotifications2FAEnabled && currentConfirmationType !== TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION && (
          <button
            className={`switch-confirmation-method-list-item ${isClicked ? 'is-clicked-cursor' : ''}`}
            onClick={() => handleSwitchConfirmationMethod(TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION)}
            disabled={isClicked}
          >
            <div className={'switch-confirmation-method-list-item-icon'}>
              <div className={'switch-confirmation-method-icon-wrapper'}>
                <TransferraAppIcon className={'switch-confirmation-method-icon'} />
              </div>
              <p className={'switch-confirmation-method-name'}>
                {i18n.getMessage('switchConfirmationMethodScreen.method.PUSH_NOTIFICATION')}
              </p>
            </div>
            <div className={'switch-confirmation-method-arrow-icon-wrapper'}>
              <RightArrowIcon className={'switch-confirmation-method-arrow-icon'} />
            </div>
          </button>
        )}

        {isGoogle2FAEnabled && currentConfirmationType !== TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH && (
          <button
            className={`switch-confirmation-method-list-item ${isClicked ? 'is-clicked-cursor' : ''}`}
            onClick={() => handleSwitchConfirmationMethod(TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH)}
            disabled={isClicked}
          >
            <div className={'switch-confirmation-method-list-item-icon'}>
              <div className={'switch-confirmation-method-icon-wrapper'}>
                <GoogleAuthenticatorIcon className={'switch-confirmation-method-icon'} />
              </div>
              <p className={'switch-confirmation-method-name'}>
                {i18n.getMessage('switchConfirmationMethodScreen.method.GOOGLE_AUTH')}
              </p>
            </div>
            <div className={'switch-confirmation-method-arrow-icon-wrapper'}>
              <RightArrowIcon className={'switch-confirmation-method-arrow-icon'} />
            </div>
          </button>
        )}

        {isWhatsApp2FAEnabled && currentConfirmationType !== TWO_FACTOR_AUTH_TYPES.WHATSAPP && (
          <button
            className={`switch-confirmation-method-list-item ${isClicked ? 'is-clicked-cursor' : ''}`}
            onClick={() => handleSwitchConfirmationMethod(TWO_FACTOR_AUTH_TYPES.WHATSAPP)}
            disabled={isClicked}
          >
            <div className={'switch-confirmation-method-list-item-icon'}>
              <div className={'switch-confirmation-method-icon-wrapper'}>
                <WhatsAppIcon className={'switch-confirmation-method-icon'} />
              </div>
              <p className={'switch-confirmation-method-name'}>
                {i18n.getMessage('switchConfirmationMethodScreen.method.WHATSAPP')}
              </p>
            </div>
            <div className={'switch-confirmation-method-arrow-icon-wrapper'}>
              <RightArrowIcon className={'switch-confirmation-method-arrow-icon'} />
            </div>
          </button>
        )}

        {isSms2FAEnabled && currentConfirmationType !== TWO_FACTOR_AUTH_TYPES.SMS && (
          <button
            className={`switch-confirmation-method-list-item ${isClicked ? 'is-clicked-cursor' : ''}`}
            onClick={() => handleSwitchConfirmationMethod(TWO_FACTOR_AUTH_TYPES.SMS)}
            disabled={isClicked}
          >
            <div className={'switch-confirmation-method-list-item-icon'}>
              <div className={'switch-confirmation-method-icon-wrapper'}>
                <SmsIcon className={'switch-confirmation-method-icon'} />
              </div>
              <p className={'switch-confirmation-method-name'}>
                {i18n.getMessage('switchConfirmationMethodScreen.method.SMS')}
              </p>
            </div>
            <div className={'switch-confirmation-method-arrow-icon-wrapper'}>
              <RightArrowIcon className={'switch-confirmation-method-arrow-icon'} />
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

SwitchConfirmationMethodScreen.propTypes = {
  onSwitchMethod: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  currentConfirmationType: PropTypes.string,
  availableConfirmationTypes: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};

export default observer(SwitchConfirmationMethodScreen);
